<template>
  <div class="banner">
    <el-col :span="24" class="action-bar">
      <!-- <span style="color:#888888;">轮播图管理:</span> -->
      <el-button type="primary" size="medium" @click="addBtnReset" style="margin: 0 20px;">新增</el-button>
    </el-col>

    <!-- 列表 -->
    <el-table
      :data="groupList"
      style="width: 100%">
      <el-table-column type="index" min-width="60"></el-table-column>
      <el-table-column
        prop="name"
        label="组名称"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="200"
      >
        <template slot-scope="scope">
          <p :title="scope.row.remark">{{scope.row.remark.slice(0,10)+'...'}}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_member_num"
        label="组员数量"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        label="排序"
        prop="sort"
        min-width="60">
      </el-table-column>

      <el-table-column label="操作" min-width='200'>
        <template slot-scope="scope">
          <el-button size="mini" type='primary' @click="getGroupDetail(scope.row.id)">编辑</el-button>
          <el-button size="mini" type='primary' @click="toGroupMembers(scope.row.id)">组成员</el-button>
          <el-button size="mini" type='danger' @click="delGroup(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-col :span="24" class="footer-bar">
      <!-- <div class="batch"><el-button size="medium ">批量删除</el-button></div> -->
      <div class="page-code">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageTotal"
          :page-size="limit"
          @current-change="getGroupList"
        >
        </el-pagination>
      </div>
    </el-col>


    <el-dialog title="新增组" :visible.sync="addFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="组名称">
          <el-input v-model="addForm.name" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="addForm.sort" type="number" min="0" style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCancelBtn">取消</el-button>
        <el-button type="primary" @click="addSubmitBtn">提交</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title="编辑组" :visible.sync="editFormVisible" width="40%">
      <el-form label-width="80px">
        <el-form-item label="组名称">
          <el-input v-model="setForm.name" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="setForm.remark" type="textarea" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="setForm.sort" type="number" min="0" style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCancelBtn">取消</el-button>
        <el-button type="primary" @click="editSubmitBtn">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
      name: "customer_group",
      data(){
        return{
          addFormVisible: false, //添加弹窗
          editFormVisible: false, //编辑弹窗
          groupList:[],
          pageTotal:0,
          limit: 10,

          addForm:{
            name: '',
            remark: '',
            sort: 0
          },

          setForm:{
            name: '',
            remark: '',
            sort: '',
            id: ''
          }
        }
      },
      mounted(){
        this.getGroupList()
      },
      methods:{
        //获取组列表
        async getGroupList(page){
          let params = {
            page: page||1,
            limit: this.limit
          }
          const res = await this.$api.getGroupList(params);
          if (res.data.level=='success') {
            this.groupList = res.data.data;
            this.pageTotal = res.data.page_info.total
          }else {
            this.$message({
              message: res.data.message,
              type: 'warning'
            });
          }
        },
        //获取组详情
        async getGroupDetail(id){
          const res = await this.$api.getGroupDetail({id:id});
          if (res.data.level == 'success'){
            this.setForm.id = res.data.data.id;
            this.setForm.name = res.data.data.name;
            this.setForm.sort = res.data.data.sort;
            this.setForm.remark = res.data.data.remark;
            this.editFormVisible = true;
          } else{
            this.$message({
              message: res.data.message,
              type: 'warning'
            });
          }
        },
        //添加提交按钮
        async addSubmitBtn(){
          const res = await this.$api.setGroup(this.addForm);
          if (res.data.level == 'success'){
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.addCancelBtn();
            this.getGroupList();
          }else {
            this.$message({
              message: res.data.message,
              type: 'warning'
            });
          }
        },
        //新增取消按钮
        addCancelBtn(){
          this.addForm.name = "";
          this.addForm.sort = 0;
          this.addForm.remark = "";
          this.addFormVisible = false;
        },
        //新增按钮重置表单
        addBtnReset(){
          this.addForm.name = "";
          this.addForm.sort = 0;
          this.addForm.remark = "";
          this.addFormVisible = true;
        },
        //编辑提交按钮
        async editSubmitBtn(){
          const res = await this.$api.setGroup(this.setForm);
          if (res.data.level == 'success'){
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.editCancelBtn();
            this.getGroupList();
          }else {
            this.$message({
              message: res.data.message,
              type: 'warning'
            });
          }
        },
        //编辑取消按钮
        editCancelBtn(){
          this.setForm.id = "";
          this.setForm.name = "";
          this.setForm.sort = "";
          this.addForm.remark = "";
          this.editFormVisible = false;
        },
        //删除组
        async delGroup(id){
          const res = await this.$api.delGroup({id:id});
          if (res.data.level == 'success'){
            this.$message({
              type: 'success',
              message: res.data.message
            });
            this.getGroupList();
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            });
          }
        },
        toGroupMembers(id){
          this.$router.push({name: 'Group_Members', query: {id: id}})
        }
      }
    }
</script>

<style lang='scss' scoped>
  .banner{
    .action-bar{
      background-color: #f2f2f2;
      height: 60px;
      margin: 10px 0px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: 20px;
      .action-bar-input{
        width: 250px;
        margin-right: 14px;
      }
    }
    .el-table-style{
      width: 100%;
      border: 1px solid #f2f2f2;
    }
    .footer-bar{
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f2f2f2;
      padding: 8px;
      margin: 10px 0px;
      box-sizing: border-box;
    }
    .dialog-footer{
      text-align: center;
    }
  }
</style>

<style>
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next
  {
    background-color: #fff;
    border: 1px solid #f1f1f1;
    margin: 0;
  }
  .member .el-dialog__body{overflow: auto;}
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/customer_group.vue